<template>
  <tab-content-layout title="SAÍDA">
    <b-row class="v-clean">
      <b-col>
        <b-row>
          <b-col class="pt-0 pb-0">
            <h4 class="title-pages">PRODUTO/MEDICAMENTO</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-autocomplete-default
              item-text="name"
              item-value="id"
              :items="residents"
              label="PROPRIETÁRIO"
              v-model="resident_id"
              @change="getStockedItems"
            />
          </b-col>
          <b-col>
            <v-autocomplete-default
              item-text="name"
              item-value="id"
              :items="groups"
              label="GRUPO"
              v-model="stock_group_id"
              @change="getStockedItems"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-select-default
              label="TIPO"
              :items="types"
              v-model="stock_item_type_id"
              @change="getStockedItems"
            />
          </b-col>
          <b-col>
            <v-autocomplete-default
              label="CATEGORIA"
              :items="categories"
              v-model="stock_item_category_id"
              @change="getStockedItems"
            />
          </b-col>
          <b-col>
            <v-text-field-default
              label="BUSCAR"
              v-model="search_stocked_items"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="pt-0 pb-0">
            <b-overlay :show="loadingItems" opacity="0.99">
              <div
                v-show="resident_id && stocked_items.length > 0"
                class="col-12 m-0 p-0"
              >
                <p class="m-0 text-fourteen color-sysblue mb-1">
                  SÓ É POSSÍVEL REALIZAR SAÍDA DE LOTES QUE NÃO ESTEJAM SEPARADO
                  DO RESIDENTE SELECIONADO!
                </p>
              </div>
              <v-data-table-default
                :search="search_stocked_items"
                :headers="stocked_items_headers"
                :items="stocked_items"
                :footerProps="{
                  'items-per-page-options': [30, 50, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
              >
                <template #item="{ item }">
                  <tr
                    :class="[
                      itemAddedToExecute(item) && 'tr-item-added-to-execute',
                    ]"
                  >
                    <td class="td-item-input-radio">
                      <p
                        class="m-0 text-center"
                        v-show="itemAddedToExecute(item)"
                      >
                        Já adicionou!
                      </p>
                      <v-radio-group
                        class="m-0 p-0"
                        v-model="selected_stocked_item_id"
                        dense
                      >
                        <v-radio
                          class="m-0 p-0"
                          :key="item.id"
                          label=""
                          :value="item"
                          v-show="!itemAddedToExecute(item)"
                        />
                      </v-radio-group>
                    </td>
                    <td>
                      {{
                        item.stock_item_type_value == "MEDICINE"
                          ? item.medicine_name
                          : item.product_name
                      }}
                    </td>
                    <td>
                      {{ item.stock_group_name }}
                    </td>
                    <td>
                      {{ item.stock_item_type_name }}
                    </td>
                    <td>
                      {{ item.stock_item_category_name }}
                    </td>
                    <td>
                      {{ item.amount }}
                      {{ item.stock_item_unit_of_measurement_abbreviation }}
                    </td>
                    <td>
                      {{ item.lot }}
                    </td>
                    <td>
                      {{ moment(item.entry_date).format("DD/MM/YYYY") }}
                    </td>
                    <td>
                      {{
                        item.due_date
                          ? moment(item.due_date).format("MM/YYYY")
                          : "NÃO INFORMADO"
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table-default>
            </b-overlay>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="pt-0 pb-0">
            <h4 class="title-pages">QUANTIDADE</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="">
            <v-text-field-default
              type="number"
              label="QUANTIDADE*"
              v-model.number="amount"
            />
          </b-col>
        </b-row>
        <warning-required-fields />
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn-add
              :disabled="btnCreateOrderDisabled"
              @click="createOrder"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="v-clean my-3">
      <b-col>
        <b-row>
          <b-col class="pt-0 pb-0">
            <h4 class="title-pages">SAÍDAS</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="pt-0 pb-0">
            <v-data-table-default
              :headers="output_orders_headers"
              :items="computed_output_orders"
            >
              <template #[`item.amount`]="{ item }">
                {{ item.amount }}
                {{ item.stock_item_unit_of_measurement_abbreviation }}
              </template>
              <template #[`item.lot`]="{ item }">
                {{ item.lot }}
              </template>
              <template #[`item.entry_date`]="{ item }">
                {{ moment(item.entry_date).format("DD/MM/YYYY") }}
              </template>
              <template #[`item.due_date`]="{ item }">
                {{
                  item.due_date
                    ? moment(item.due_date).format("MM/YYYY")
                    : "NÃO INFORMADO"
                }}
              </template>
              <template #[`item.actions`]="{ item }">
                <v-data-table-remove-button @click="removeOrder(item.index)" />
              </template>
            </v-data-table-default>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <errors-messages :errors="errors" />
    <b-row align-h="end">
      <b-col cols="auto">
        <v-btn-save
          :disabled="loading || output_orders.length === 0"
          :loading="loading"
          text="EXECUTAR"
          @click="execute"
        />
      </b-col>
    </b-row>
  </tab-content-layout>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import TabContentLayout from "../../Components/TabContentLayout.vue";
import VDataTableDefault from "../../Components/VDataTableDefault.vue";
import VSelectDefault from "../../Components/VSelectDefault.vue";
import VTextFieldDefault from "../../Components/VTextFieldDefault.vue";
import VBtnSave from "../../Components/VBtnSave.vue";
import VBtnAdd from "../../Components/VBtnAdd.vue";
import VDataTableRemoveButton from "../../Components/VDataTableRemoveButton.vue";

import api from "../../../services/api";

import APIGet from "../../../lib/api-get";

import toast from "../../../lib/ToastNotification";

import moment from "moment";
import WarningRequiredFields from "../../Components/WarningRequiredFields.vue";
import VAutocompleteDefault from "../../Components/VAutocompleteDefault.vue";

export default {
  name: "Output",

  components: {
    TabContentLayout,
    VSelectDefault,
    VDataTableDefault,
    VTextFieldDefault,
    ErrorsMessages,
    VBtnSave,
    VBtnAdd,
    VDataTableRemoveButton,
    WarningRequiredFields,
    VAutocompleteDefault,
  },

  data() {
    return {
      status_resident: "ATIVO",

      errors: [],
      selected_stocked_item_id: {},
      loading: false,
      loadingItems: false,

      stock_item_units_of_measurement: [],

      raw_residents: [],
      stock_groups: [],
      stocked_items: [],
      stock_item_types: [],
      stock_item_categories: [],
      search_stocked_items: "",

      stocked_items_headers: [
        { text: "", value: "radio" },
        { text: "NOME", value: "stock_item_name" },
        { text: "GRUPO", value: "stock_group_name" },
        { text: "TIPO", value: "stock_item_type_name" },
        { text: "CATEGORIA", value: "stock_item_category_name" },
        { text: "QUANTIDADE", value: "amount" },
        { text: "LOTE", value: "lot" },
        { text: "DT/ENTRADA", value: "entry_date" },
        { text: "DT/VENCIMENTO", value: "due_date" },
      ],
      selected_stocked_items: [],

      stock_item_type_id: null,
      stock_item_category_id: null,
      resident_id: null,
      stock_group_id: null,
      amount: "",

      output_orders_headers: [
        { text: "PROPRIETÁRIO", value: "owner_name" },
        { text: "GRUPO", value: "stock_group_name" },
        { text: "ITEM", value: "stock_item_name" },
        { text: "QUANTIDADE", value: "amount" },
        { text: "LOTE", value: "lot" },
        { text: "DT/ENTRADA", value: "entry_date" },
        { text: "DT/VENCIMENTO", value: "due_date" },
        { text: "AÇÕES", value: "actions" },
      ],
      output_orders: [],
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    residents() {
      return [{ id: null, name: "EMPRESA" }, ...this.raw_residents];
    },

    groups() {
      return [{ id: null, name: "SELECIONE" }, ...this.stock_groups];
    },

    types() {
      return [{ id: null, name: "SELECIONE" }, ...this.stock_item_types];
    },

    categories() {
      return [
        { id: null, name: "SELECIONE" },
        ...this.stock_item_categories.filter(
          (item) => item.stock_item_type_id === this.stock_item_type_id
        ),
      ];
    },

    stocked_item() {
      return this.selected_stocked_items[0] ?? null;
    },

    btnCreateOrderDisabled() {
      if (!this.stocked_item) return true;
      if (
        !this.amount ||
        this.amount <= 0 ||
        this.amount > this.stocked_item.amount
      )
        return true;

      return false;
    },

    computed_output_orders() {
      return this.output_orders.map((output_order, index) => ({
        ...output_order,
        index,
        owner_name: this.residents.find(
          (owner) => owner.id === output_order.resident_id
        ).name,
      }));
    },
  },

  watch: {
    stocked_item() {
      this.amount = this.stocked_item?.amount ?? "";
    },

    selected_stocked_item_id() {
      if (this.selected_stocked_item_id.id) {
        this.selected_stocked_items = [this.selected_stocked_item_id];
      } else {
        this.selected_stocked_items = [];
      }
    },
  },

  methods: {
    moment,

    itemAddedToExecute(item) {
      let { output_orders } = this;

      let exist = output_orders.find(
        (output_order) => output_order.stocked_item_id == item.id
      );

      if (exist) {
        return true;
      }

      return false;
    },

    //#region getters
    async retrieve() {
      if (this.errors.length === 0) await this.getTypes();
      if (this.errors.length === 0) await this.getUnitsOfMeasurement();
      if (this.errors.length === 0) await this.getCategories();
      if (this.errors.length === 0) await this.getResidents();
      if (this.errors.length === 0) await this.getStockGroups();
      if (this.errors.length === 0) await this.getStockItems();
      if (this.errors.length === 0) await this.getStockedItems();
    },

    async getStockGroups() {
      this.loading = true;
      const { error, errors, stock_groups } = await APIGet.getStockGroups();
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async getTypes() {
      this.loading = true;
      const { error, errors, stock_item_types } =
        await APIGet.getStockItemTypes();
      this.errors = errors;
      this.stock_item_types = error ? [] : stock_item_types;
      this.loading = false;
    },

    async getCategories() {
      this.loading = true;
      const { error, errors, stock_item_categories } =
        await APIGet.getStockItemCategories();
      this.errors = errors;
      this.stock_item_categories = error ? [] : stock_item_categories;
      this.loading = false;
    },

    async getStockItems() {
      this.loading = true;
      const { error, errors, stock_items } = await APIGet.getStockItems();
      this.errors = errors;
      this.stock_items = error ? [] : stock_items;
      this.loading = false;
    },

    async getStockedItems() {
      this.loadingItems = true;

      const { errors, stocked_items } = await APIGet.getStockedItems({
        resident_id: this.resident_id,
        stock_group_id: this.stock_group_id,
        stock_item_type_id: this.stock_item_type_id,
        stock_item_category_id: this.stock_item_category_id,
      });

      this.errors = errors;

      let items = [];
      for (let stocked_item of stocked_items) {
        if (stocked_item.amount > 0) {
          let unit_of_measurement_abbreviation =
            stocked_item?.stock_item_unit_of_measurement?.abbreviation ?? "";

          items.push({
            ...stocked_item,
            unit_of_measurement_abbreviation,
          });
        }
      }

      this.stocked_items = items;
      this.loadingItems = false;
    },

    async getUnitsOfMeasurement() {
      this.loading = true;
      const { error, errors, stock_item_units_of_measurement } =
        await APIGet.getStockItemUnitsOfMeasurement();
      this.errors = errors;
      this.stock_item_units_of_measurement = error
        ? []
        : stock_item_units_of_measurement;
      this.loading = false;
    },

    async getResidents() {
      this.loading = true;
      let { status_resident } = this;
      const { error, errors, residents } = await APIGet.getResidents({
        status_resident,
      });
      this.errors = errors;
      this.raw_residents = error ? [] : residents;
      this.loading = false;
    },
    //#endregion

    createOrder() {
      const output_order = this.output_orders.find(
        (order) => order.stocked_item_id === this.stocked_item.id
      );

      let {
        id,
        lot,
        stock_group_name,
        medicine_name,
        product_name,
        stock_item_type_value,
      } = this.stocked_item;

      if (output_order) {
        output_order.amount += this.amount;
      } else {
        this.output_orders.push({
          stocked_item_id: id,
          resident_id: this.resident_id,
          lot,
          amount: this.amount,

          stock_group_name: stock_group_name,
          stock_item_name:
            stock_item_type_value == "MEDICINE" ? medicine_name : product_name,
          stock_item_unit_of_measurement_abbreviation:
            this.stocked_item.stock_item_unit_of_measurement_abbreviation,
        });
      }

      this.selected_stocked_items = [];
      this.selected_stocked_item_id = {};
    },

    removeOrder(index) {
      this.output_orders.splice(index, 1);
    },

    async execute() {
      try {
        this.loading = true;

        const data = {
          output_orders: this.output_orders.map((order) => ({
            stocked_item_id: order.stocked_item_id,
            amount: order.amount,
          })),
        };
        const response = await api.post("/rest-home/stock/output", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.output_orders = [];
          this.getStockedItems().then();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>